import Player from '@vimeo/player';

export function handleCampaignVideo() {
  const playButtons = document.querySelectorAll(
    '.video-popout__preview-container--video, .video-popout__preview-mobile-container--video',
  );

  Array.from(playButtons).forEach((button) => {
    const container = document.getElementById(button.getAttribute('data-video'));
    const video = new Player(container.querySelector('.video-popout__iframe'));
    video.pause();

    button.addEventListener('click', () => {
      container.classList.toggle('show-video');
      document.body.classList.toggle('no-scroll');
    });
  });

  const containers = document.getElementsByClassName(
    'video-popout__video-container',
  );

  Array.from(containers).forEach((container) => {
    const video = new Player(container.querySelector('.video-popout__iframe'));

    container
      .querySelector('.video-popout__close')
      .addEventListener('click', () => {
        container.classList.toggle('show-video');
        document.body.classList.toggle('no-scroll');
        video.pause();
      });

    container.addEventListener('click', (e) => {
      const wrapper = container.querySelector('.video-popout__wrapper');
      if (e.target.contains(wrapper) && e.target !== wrapper) {
        container.classList.toggle('show-video');
        document.body.classList.toggle('no-scroll');
        video.pause();
      }
    });

    container
      .querySelector('.video-popout__footer')
      .addEventListener('click', () => {
        container
          .querySelector('.video-popout__wrapper')
          .classList.toggle('show-transcript');
        container
          .querySelector('.video-popout__expand-transcript')
          .classList.toggle('open');
      });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (container.classList.contains('show-video')) {
          container.focus();
          container.classList.toggle('show-video');
          document.body.classList.toggle('no-scroll');
          video.pause();
        }
      }
    });
  });
}

export default handleCampaignVideo;
